/**
 * Configuration for experimental features that should be tagged as ALPHA
 * in the sidebar and header navigation.
 *
 * Features listed here will:
 * - Display an "ALPHA" badge (purple) in the sidebar
 * - Display an "ALPHA" badge (purple) in the header/mobile navigation
 * - Only be visible when experimental features are enabled in settings
 *
 * Additional UI elements gated by experimentalFeaturesEnabled (not in ALPHA_PATHS):
 * - Product header: Harry avatar is always shown; clicking it opens the coach chat sheet only when experimental features are enabled
 * - Drill Library: Planner button (header)
 * - Posture analysis: Re-analyze button on client saved analysis; Compare tab toolbar
 * - Posture analysis: Posterior (back) view — capture, display, and PDF export (hidden when experimental off)
 * - Client page: Export as PDF menu item for posture analyses
 *
 * Posture analysis metrics:
 * - Angle-based metrics (°) are always shown in UI and PDF export.
 * - Distance-based metrics (cm/inches) are only shown when experimental features are enabled.
 */
export const EXPERIMENTAL_FEATURES = {
  /**
   * Paths that should be tagged as ALPHA (experimental features)
   */
  ALPHA_PATHS: [
    '/agent',
    '/drill-planner',
    '/remote-assessment',
  ] as const,

  /**
   * Check if a path is an experimental ALPHA feature
   */
  isAlpha(path: string): boolean {
    return this.ALPHA_PATHS.includes(path as any);
  },

  /**
   * Get the badge type for a path
   * Returns 'alpha' for experimental features, 'beta' for other experimental items, or null
   */
  getBadgeType(path: string, isExperimental?: boolean): 'alpha' | 'beta' | null {
    if (!isExperimental) return null;
    return this.isAlpha(path) ? 'alpha' : 'beta';
  },
} as const;

export type ExperimentalFeaturePath = typeof EXPERIMENTAL_FEATURES.ALPHA_PATHS[number];




